import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { AlertCircle, RefreshCw, Inbox } from 'lucide-react';

export function TrackingSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-8 w-20 rounded bg-white/45" />
          <div>
            <div className="h-6 w-64 rounded bg-white/45" />
            <div className="mt-2 h-3 w-40 rounded bg-white/35" />
          </div>
        </div>
      </div>
      <div className="h-14 rounded-[22px] bg-white/35" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="h-28 rounded-[22px] bg-white/35" />
        <div className="h-28 rounded-[22px] bg-white/35" />
      </div>
      <div className="h-48 rounded-[22px] bg-white/35" />
    </div>
  );
}

export function ErrorState({ title = 'Something went wrong', message, onRetry }) {
  return (
    <Card className="partner-card rounded-[28px] p-10 text-center">
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full border border-[#A87DFA]/16 bg-white/45">
        <AlertCircle className="h-6 w-6 text-[#8D68E8]" />
      </div>
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      {message && <p className="mt-1 text-sm text-slate-600">{message}</p>}
      {onRetry && (
        <Button variant="outline" className="partner-secondary-btn mt-4 rounded-2xl" onClick={onRetry}>
          <RefreshCw className="w-4 h-4 mr-2" /> Retry
        </Button>
      )}
    </Card>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <Card className="partner-card rounded-[28px] p-8 text-center">
      <Icon className="mx-auto mb-2 h-10 w-10 text-[#A87DFA]" />
      <p className="font-medium text-slate-800">{title}</p>
      {description && (
        <p className="mt-1 text-sm text-slate-500">{description}</p>
      )}
      {action}
    </Card>
  );
}
